// extracted by mini-css-extract-plugin
module.exports = {"container":"Do-z","creativeContainer":"Eo-z","copy":"Fo-z","cta":"Go-z","disabled":"Ho-z","flipped":"Io-z","card":"Jo-z"};